<h2 mat-dialog-title>
  E-mailarkiv
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <p>Automatisk arkivering af kvitteringer, afslag og/eller bevillignsbreve ved at sætte en eller flere modtagere BCC på beskederne fra GrantOne.</p>
  <form [formGroup]="form" fxLayout="column">
    <div class="mb-2">
      <mat-checkbox ngDefaultControl formControlName="receipts" (change)="setValidations()">Kvitteringer</mat-checkbox>
    </div>
    <div class="mb-2">
      <mat-checkbox ngDefaultControl formControlName="rejections" (change)="setValidations()">Afslag</mat-checkbox>
    </div>
    <div class="mb-2">
      <mat-checkbox ngDefaultControl formControlName="approvals" (change)="setValidations()">Bevillingsbreve</mat-checkbox>
    </div>
    <mat-form-field>
      <mat-label>Emails</mat-label>
      <input
        type="text"
        matInput
        formControlName="email"
        >
      <mat-hint>Indtast en eller flere emailadresser. Adresserne adskilles af komma.</mat-hint>
      @if (email.hasError('required')) {
        <mat-error><strong>Skal</strong> udfyldes.</mat-error>
      }
      @if (email.hasError('email')) {
        <mat-error><strong>Ugyldig</strong> emailadresse(r).</mat-error>
      }
      @if (email.hasError('maxlength')) {
        <mat-error><strong>Højst</strong> 100 tegn.</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
</mat-dialog-actions>
